import React, { forwardRef } from 'react'

import * as S from './styles'

import type { CheckboxInputProps } from './types'

export const Checkbox = forwardRef<HTMLInputElement, CheckboxInputProps>(
  (
    {
      label,
      labelPosition = 'after',
      onClick,
      indeterminate,
      checked,
      ...restProps
    },
    ref
  ) => (
    <S.Checkbox
      onClick={onClick}
      indeterminate={indeterminate}
      isDisabled={restProps.disabled}
    >
      {label && labelPosition === 'before' && <S.Label>{label}</S.Label>}
      <input type="checkbox" ref={ref} {...restProps} checked={checked} />
      <S.CheckMark>
        {indeterminate && !checked && (
          <S.IndeterminateCheckMarkIcon data-testid="checkbox-indeterminate-icon" />
        )}
        {checked && <S.CheckMarkIcon data-testid="checkbox-checked-icon" />}
      </S.CheckMark>
      {label && labelPosition === 'after' && <S.Label>{label}</S.Label>}
    </S.Checkbox>
  )
)

Checkbox.displayName = 'Checkbox'
